import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../../../../components/icon/iconfont'
import { FormattedMessage } from 'react-intl'
import { IMAGE_GEEKO_LTD } from '../../../../../../../../constants'

export default props => {
    useStyles(classes)
    const {selectedCard, onPaymethod, onPay, paying} = props

    return <div className={`${classes.Credit} ${paying? classes.Paying: ''}`}>
        <button className={classes.Button} disabled={paying} onClick={onPay}>
            {
                selectedCard ? <span>
                    <span className={classes.CardButton}>
                        {
                            !paying && selectedCard.style?.imageURL && <img className={classes.Brand} src={selectedCard.style.brandImage || selectedCard.style.imageURL}/>
                        }

                        {
                            paying && <Iconfont className={classes.LoadIcon}>&#xe62d;</Iconfont>
                        }

                        <span className={classes.CardNumber}>
                            {
                                selectedCard.quickpayRecord?.cardNumber
                            }
                        </span>
                    </span>

                    <span className={classes.ButtonPay}>
                        <FormattedMessage id="pay_now" defaultMessage="Pay Now"/>
                    </span>
                </span>: 
                
                <>
                    {
                        !paying && <img className={classes.Brand} src={`${IMAGE_GEEKO_LTD}/chicme/20230403/credit-card-svgrepo-com.svg`}/>
                    }

                    {
			            paying && <Iconfont className={classes.LoadIcon}>&#xe62d;</Iconfont>
		            }
                    <span className={classes.PayNowText}>
                        <FormattedMessage id="pay_now" defaultMessage="Pay Now"/>
                    </span>
                </> 
            }
        </button>
        <button className={classes.Select} disabled={paying} onClick={onPaymethod}>
            <Iconfont className={classes.Icon}>&#xe727;</Iconfont>
        </button>
    </div>
}